export default {
    NATIONAL: 1,
    DEPARTEMENTAL: 2,
    LOCAL: 3,
};
export const PERIMETRE_NATIONAL_ID = 1;
